/* import __COLOCATED_TEMPLATE__ from './localised-content-container.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();